import { render } from "./AngleIcon.vue?vue&type=template&id=348da1ef&scoped=true"
const script = {}

import "./AngleIcon.vue?vue&type=style&index=0&id=348da1ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348da1ef"]])

export default __exports__